import { render } from "./MomentView.vue?vue&type=template&id=a1e199ea&scoped=true"
import script from "./MomentView.vue?vue&type=script&lang=js"
export * from "./MomentView.vue?vue&type=script&lang=js"

import "./MomentView.vue?vue&type=style&index=0&id=a1e199ea&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e199ea"]])

export default __exports__